import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import AssetGallery, { ASSET_TYPE_IMAGE, ASSET_TYPE_VIDEO } from "template-store/components/asset-gallery/asset-gallery";
import TemplateBenefits from "template-store/components/template-benefits/template-benefits";
import TemplateLongDescription from "template-store/components/template-long-description/template-long-description";
import { StyledTemplateOverviewContent } from "./template-overview-content.scss";
const TemplateOverviewContent = (props)=>{
    const { templateData } = props;
    const { images, videoLink, longDescription } = templateData;
    const assetsList = useMemo(()=>{
        const list = images.map((imageData)=>{
            return {
                src: imageData.url,
                title: imageData.title,
                type: ASSET_TYPE_IMAGE
            };
        });
        if (videoLink) {
            list.splice(1, 0, {
                src: videoLink,
                type: ASSET_TYPE_VIDEO
            }); //currently we always put the video as the 2nd item
        }
        return list;
    }, [
        images,
        videoLink
    ]);
    return /*#__PURE__*/ _jsxs(StyledTemplateOverviewContent, {
        className: "template-overview-content",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "images-wrapper",
                children: /*#__PURE__*/ _jsx(AssetGallery, {
                    assets: assetsList
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "template-benefits-wrapper",
                children: /*#__PURE__*/ _jsx(TemplateBenefits, {
                    benefits: templateData === null || templateData === void 0 ? void 0 : templateData.benefits
                })
            }),
            longDescription && /*#__PURE__*/ _jsxs("div", {
                className: "template-long-description-wrapper",
                children: [
                    /*#__PURE__*/ _jsx("hr", {
                        className: "template-long-description-divider"
                    }),
                    /*#__PURE__*/ _jsx(TemplateLongDescription, {
                        descriptions: longDescription
                    })
                ]
            })
        ]
    });
};
export default TemplateOverviewContent;
